export default __webpack_public_path__ + "static/media/roboto-v20-latin-regular.4f862c8b.svg";